import { useMutation } from "@tanstack/react-query";

import { apiPaths } from "@/config/paths";
import type { MutationConfig } from "@/lib/react-query";
import { authApi } from "@/lib/api-client";
import { AxiosResponse } from "axios";

type GetSoftwareStatementResponse = {
  software_statement: string;
};

type GetSoftwareStatementInput = {
  expiresIn?: number;
  permissions?: {
    include?: string[];
    exclude?: string[];
  };
};
const getSoftwareStatement = (
  data: GetSoftwareStatementInput
): Promise<AxiosResponse<GetSoftwareStatementResponse>> => {
  return authApi.post<GetSoftwareStatementInput, AxiosResponse<GetSoftwareStatementResponse>>(
    apiPaths.auth.getSoftwareStatement.getPath(),
    data
  );
};

type UseGetSoftwareStatementOptions = {
  mutationConfig?: MutationConfig<typeof getSoftwareStatement>;
};

export const useGetSoftwareStatement = ({ mutationConfig }: UseGetSoftwareStatementOptions = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (data, ...args) => {
      onSuccess?.(data, ...args);
    },
    ...restConfig,
    mutationFn: getSoftwareStatement,
  });
};
